import { ButtonBase, Typography as T } from "@mui/material";

import { reduceIconPath } from "helpers/functions";
import { palette } from "theme/palette";

type Props = {
  onClick: () => void;
  disableBackButton: boolean;
};

export const BackButton = ({ onClick, disableBackButton }: Props) => {
  return (
    <ButtonBase
      sx={{
        background: palette.white,
        width: [80, 126, 206],
        height: [46, 50, 54],
        borderRadius: "8px",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: palette.grey,
        opacity: "1",
        cursor: `${disableBackButton ? "default" : "pointer"}`,
      }}
      onClick={onClick}
      disabled={disableBackButton}
    >
      {disableBackButton ? (
        <img
          src={reduceIconPath("back-button-icon-disabled.svg")}
          alt={"back button disabled"}
        />
      ) : (
        <img src={reduceIconPath("back-button-icon.svg")} alt={"back button"} />
      )}

      <T
        variant="h5sb"
        sx={{
          color: disableBackButton ? palette.lightGrey : palette.accent,
          marginLeft: 1,
          fontSize: [16, 18],
        }}
      >
        Back
      </T>
    </ButtonBase>
  );
};
